import _ from 'lodash';
import { helperGetApiRouteById } from 'helpers/ApiHelper';

export const getArticleApiId = articleUrl => {
  const contentId = _.split(articleUrl, '/').pop();
  return _.split(contentId, '-').pop();
};

export const getArticleApiUrl = articleUrl =>
  helperGetApiRouteById('articleDetail', getArticleApiId(articleUrl), '{articleId}');

export const getPurifyConfig = () => ({
  USE_PROFILES: {
    html: true,
  },
  ADD_ATTR: ['target'],
});

export const IFRAME_TEST_PATTERN = /<iframe.*?src=['"](.*?)['"].*<\/iframe>/im;
export const SCRIPT_TEST_PATTERN = /<script.*?>(.*)<\/script>/im;
